// Admin → Marketing → Prospectos de anfitriones: utilidades compartidas por los
// componentes del CRM (CrmAnfitriones.vue y sus hijos). Sin estado propio.
import * as XLSX from 'xlsx';

export const DAY = 864e5;

export const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
export const norm = s => String(s == null ? '' : s).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/\s+/g, ' ').trim();

/* ── Íconos (texto fijo de este archivo, nunca datos del usuario) ── */
const ic = p => `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="${p}" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
export const I = {
    close: ic('M6 6l12 12M18 6 6 18'),
    more: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="5" cy="12" r="1.8" fill="currentColor"/><circle cx="12" cy="12" r="1.8" fill="currentColor"/><circle cx="19" cy="12" r="1.8" fill="currentColor"/></svg>',
    plus: ic('M12 5v14M5 12h14'),
    pin: ic('M12 21s-7-6.2-7-11.5A7 7 0 0 1 19 9.5C19 14.8 12 21 12 21Zm0-9a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z'),
    user: ic('M20 21a8 8 0 0 0-16 0M12 13a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z'),
    mail: ic('M4 6h16v12H4zM4 7l8 6 8-6'),
    web: ic('M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM3 12h18M12 3c2.5 2.6 3.8 5.6 3.8 9s-1.3 6.4-3.8 9c-2.5-2.6-3.8-5.6-3.8-9S9.5 5.6 12 3Z'),
    in: '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M5 3.5a2 2 0 1 1 0 4 2 2 0 0 1 0-4ZM3.3 9h3.4v11.5H3.3zM9 9h3.3v1.6c.5-.9 1.7-1.9 3.6-1.9 3.6 0 4.3 2.3 4.3 5.4v6.4h-3.4v-5.7c0-1.4 0-3.1-1.9-3.1s-2.2 1.5-2.2 3v5.8H9z"/></svg>',
    clock: ic('M12 8v4l2.5 2.5M21 12a9 9 0 1 1-9-9 9 9 0 0 1 9 9Z'),
    cal: ic('M5 5h14v15H5zM5 10h14M9 3v4M15 3v4'),
    move: ic('M5 12h14m-4-4 4 4-4 4'),
    note: ic('M5 4h14v12l-4 4H5zM15 20v-4h4M8 9h8M8 13h5'),
    edit: ic('M4 20h4L19 9l-4-4L4 16zM13.5 6.5l4 4'),
    trash: ic('M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13'),
    copy: ic('M8 8h12v12H8zM16 8V4H4v12h4'),
    ext: ic('M14 4h6v6M20 4l-9 9M18 14v6H4V6h6'),
    chev: ic('m6 9 6 6 6-6'),
    left: ic('m15 6-6 6 6 6'),
    right: ic('m9 6 6 6-6 6'),
    back: ic('M15 18l-6-6 6-6'),
    fold: ic('M9 5v14M15 5v14'),
    flag: ic('M5 21V4h11l-1.5 4L16 12H5'),
    building: ic('M4 21V4h10v17M14 9h6v12M3 21h18M8 8h2M8 12h2M8 16h2M17 13h.01M17 17h.01'),
    tag: ic('M3 12V4h8l10 10-8 8-10-10ZM7.5 8h.01'),
    brief: ic('M4 8h16v12H4zM9 8V5h6v3M4 13h16'),
    check: ic('m5 12 5 5L20 7'),
    info: ic('M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM12 11v5M12 8h.01'),
    warn: ic('M12 3 2 20h20L12 3ZM12 10v4M12 17h.01'),
    file: ic('M14 3H6v18h12V7zM14 3v4h4M9 13l2 2 4-4'),
    upload: ic('M12 15V3m0 12-4-4m4 4 4-4M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2'),
    download: ic('M12 3v12m0-12L8 7m4-4 4 4M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2'),
    board: ic('M4 4h4v16H4zM10 4h4v10h-4zM16 4h4v13h-4z'),
    list: ic('M8 6h12M8 12h12M8 18h12M4 6h.01M4 12h.01M4 18h.01'),
    search: ic('m21 21-4.3-4.3M11 18a7 7 0 1 1 0-14 7 7 0 0 1 0 14Z'),
    sort: ic('m7 14 5-5 5 5'),
    filter: ic('M4 6h16M7 12h10M10 18h4'),
    reload: ic('M20 11a8 8 0 1 0-2.3 5.7M20 5v6h-6'),
    up: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5 4 17h16z" fill="currentColor"/></svg>',
    mid: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="6" fill="currentColor"/></svg>',
    down: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 19 4 7h16z" fill="currentColor"/></svg>',
};
export const PRI_IC = { alta: I.up, media: I.mid, baja: I.down, '': '' };
export const PRIORIDADES = ['alta', 'media', 'baja', ''];
export const PRI_ORDEN = { alta: 1, media: 2, baja: 3 };
export const COLORES = ['#ff7a00', '#6d3ce0', '#0d837c', '#B91E7C', '#2f5fb8', '#a26812', '#c23a2d', '#1a8a5e'];

/* ── Fechas y tiempos ── */
const LOCALES = { es: 'es-CL', en: 'en-US', pt: 'pt-BR', fr: 'fr-FR', it: 'it-IT', de: 'de-DE' };
export const locale = l => LOCALES[l] || 'es-CL';

export function fecha(ts, loc, hora = true) {
    const o = { day: 'numeric', month: 'short', year: 'numeric' };
    if (hora) { o.hour = '2-digit'; o.minute = '2-digit'; }
    return new Date(ts).toLocaleString(loc, o);
}
/** Duración corta: "5 min", "3 h", "2 d 4 h", "27 d". `u` = unidades traducidas {min,h,d}. */
export function dur(ms, u) {
    const m = Math.max(0, Math.round(ms / 6e4));
    if (m < 60) return `${m} ${u.min}`;
    const h = Math.floor(m / 60);
    if (h < 24) return `${h} ${u.h}`;
    const d = Math.floor(h / 24), rh = h % 24;
    return `${d} ${u.d}` + (rh && d < 3 ? ` ${rh} ${u.h}` : '');
}
export const diaClave = ts => new Date(ts).toDateString();

/** Semáforo del tiempo en el estado: Pendiente 3/7 días, otros 7/14, finales sin alerta. */
export function nivelEdad(ms, est) {
    if (!est || est.fin) return '';
    const d = ms / DAY, [w, l] = est.pend ? [3, 7] : [7, 14];
    return d >= l ? 'late' : d >= w ? 'warn' : '';
}

/* ── Texto ── */
export function iniciales(n) {
    const p = String(n || '?').trim().split(/\s+/);
    return ((p[0] || '?')[0] + ((p[1] || '')[0] || (p[0] || '')[1] || '')).toUpperCase();
}
export const urlOk = u => {
    const s = String(u || '').trim();
    if (/^https?:\/\//i.test(s)) return s;
    return s && /^[\w-]+(\.[\w-]+)+/.test(s) ? 'https://' + s : '';
};
export const dominio = u => { try { return new URL(urlOk(u)).hostname.replace(/^www\./, ''); } catch (e) { return String(u || ''); } };
export const ciudadesDe = c => String(c.ciudades || '').split(/[;,]/).map(s => s.trim()).filter(Boolean);
export const correoOk = v => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);

export function copiar(txt) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(txt);
    return new Promise((res, rej) => {
        const ta = document.createElement('textarea');
        ta.value = txt; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
        document.body.appendChild(ta); ta.select();
        try { document.execCommand('copy') ? res() : rej(); } catch (e) { rej(e); }
        ta.remove();
    });
}

/* ── Excel ── */
/** Columnas que se reconocen al importar (por nombre, sin mayúsculas ni acentos). */
export const ALIAS = {
    'Empresa': ['empresa', 'compania', 'company', 'nombre empresa', 'operador'],
    'Ciudades': ['ciudades', 'ciudad', 'city', 'cities'],
    'Tipo de operador': ['tipo de operador', 'tipo', 'tipo operador'],
    'Web': ['web', 'sitio web', 'website', 'url', 'pagina web'],
    'Email': ['email', 'correo', 'mail', 'e-mail'],
    'Nombre contacto': ['nombre contacto', 'contacto', 'nombre de contacto', 'persona'],
    'Cargo': ['cargo', 'puesto', 'rol'],
    'LinkedIn personal': ['linkedin personal', 'linkedin'],
    'LinkedIn empresa': ['linkedin empresa', 'linkedin company'],
    'Prioridad': ['prioridad', 'priority'],
    'Status': ['status', 'estado', 'etapa'],
    'Asignada a': ['asignada a', 'asignado', 'asignado a', 'broker'],
};

/** Lee el archivo y devuelve { hoja, mapa, ignoradas, filas[] } con las columnas de ALIAS. */
export function leerExcel(buf) {
    const wb = XLSX.read(buf, { type: 'array' });
    for (const hoja of wb.SheetNames) {
        const filas = XLSX.utils.sheet_to_json(wb.Sheets[hoja], { header: 1, defval: '', raw: false });
        for (let h = 0; h < Math.min(10, filas.length); h++) {
            const cab = filas[h].map(x => norm(x));
            if (!cab.some(x => ALIAS.Empresa.includes(x))) continue;
            const mapa = {}, usadas = new Set();
            Object.keys(ALIAS).forEach(campo => {
                let i = cab.findIndex((x, j) => !usadas.has(j) && x === norm(campo));
                if (i < 0) i = cab.findIndex((x, j) => !usadas.has(j) && ALIAS[campo].includes(x));
                if (i >= 0) { mapa[campo] = i; usadas.add(i); }
            });
            const ignoradas = filas[h].map((x, j) => (usadas.has(j) || !String(x).trim() ? null : String(x).trim())).filter(Boolean);
            const datos = filas.slice(h + 1).map((r, k) => {
                const o = { _fila: h + k + 2 };
                Object.keys(mapa).forEach(c => { o[c] = String(r[mapa[c]] == null ? '' : r[mapa[c]]).trim(); });
                return o;
            }).filter(o => Object.keys(mapa).some(c => o[c]));
            return { hoja, mapa, ignoradas, filas: datos };
        }
    }
    const e = new Error('sin_empresa');
    e.sinEmpresa = true;
    throw e;
}
export const letraColumna = i => XLSX.utils.encode_col(i);

/** Descarga un .xlsx con las hojas [{nombre, filas, anchos}]. */
export function descargarExcel(nombre, hojas) {
    const wb = XLSX.utils.book_new();
    hojas.forEach(h => {
        const ws = XLSX.utils.json_to_sheet(h.filas.length ? h.filas : [{}]);
        if (h.anchos) ws['!cols'] = h.anchos.map(w => ({ wch: w }));
        XLSX.utils.book_append_sheet(wb, ws, h.nombre);
    });
    XLSX.writeFile(wb, nombre);
}
